(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aparu-campaign-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aparu-entry-film')) {
  customElements.define('aparu-entry-film', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      this.label = this.querySelector('[data-label]');
      this.notice = this.querySelector('[role="status"]');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.narrow = matchMedia('(max-width: 749px)');
      this.manualPause = false;
      this.explicitPlay = false;
      this.visible = false;
      this.failed = false;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const chosen = this.narrow.matches ? this.dataset.mobile || this.dataset.desktop : this.dataset.desktop || this.dataset.mobile;
      if (!chosen || !this.video) return;
      this.button.hidden = false;
      this.video.muted = true;
      this.source = chosen;
      this.narrow.addEventListener('change', () => {
        const next = this.narrow.matches ? this.dataset.mobile || this.dataset.desktop : this.dataset.desktop || this.dataset.mobile;
        if (!next || next === this.source) return;
        this.source = next;
        this.failed = false;
        this.removeAttribute('data-ready');
        this.video.pause();
        if (this.video.getAttribute('src')) {
          this.video.removeAttribute('src');
          this.video.load();
        }
        this.resume();
      }, options);
      this.button.addEventListener('click', () => {
        if (!this.video.paused) {
          this.manualPause = true;
          this.explicitPlay = false;
          this.video.pause();
        } else {
          this.manualPause = false;
          this.explicitPlay = true;
          this.failed = false;
          this.play();
        }
      }, options);
      this.video.addEventListener('playing', () => {
        this.setAttribute('data-ready', '');
        this.notice.textContent = '';
        this.button.setAttribute('aria-label', this.dataset.pauseLabel);
        this.label.textContent = this.dataset.pauseShort;
        this.button.firstElementChild.textContent = 'Ⅱ';
      }, options);
      this.video.addEventListener('pause', () => this.pausedLabel(), options);
      this.video.addEventListener('error', () => {
        this.failed = true;
        this.removeAttribute('data-ready');
        this.pausedLabel();
        this.notice.textContent = this.dataset.errorLabel;
      }, options);
      this.reduced.addEventListener('change', () => {
        this.explicitPlay = false;
        if (this.reduced.matches) {
          this.video.pause();
          this.removeAttribute('data-ready');
        } else this.resume();
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.video.pause();
        else this.resume();
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (this.visible) this.resume();
        else this.video.pause();
      }, { threshold: 0.1 });
      this.observer.observe(this);
    }
    pausedLabel() {
      this.button.setAttribute('aria-label', this.dataset.playLabel);
      this.label.textContent = this.dataset.playLabel;
      this.button.firstElementChild.textContent = '▶';
    }
    resume() {
      if (this.visible && !document.hidden && !this.manualPause && !this.failed && (!this.reduced.matches || this.explicitPlay)) this.play();
    }
    play() {
      if (!this.video.getAttribute('src')) this.video.src = this.source;
      this.video.play().catch(() => {
        this.failed = true;
        this.removeAttribute('data-ready');
        this.pausedLabel();
        this.notice.textContent = this.dataset.errorLabel;
      });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.events?.abort();
      this.video?.pause();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aparu-prelaunch"]) return;
  try {
    
function initAparuLaunch(){document.querySelectorAll('[data-aparu-countdown]').forEach(function(timer){if(timer.dataset.running)return;timer.dataset.running='true';const target=Date.parse(timer.dataset.aparuCountdown);function tick(){const remaining=Math.max(0,Math.floor((target-Date.now())/1000));const units={days:Math.floor(remaining/86400),hours:Math.floor(remaining/3600)%24,minutes:Math.floor(remaining/60)%60,seconds:remaining%60};Object.keys(units).forEach(function(key){const node=timer.querySelector('[data-unit="'+key+'"]');if(node)node.textContent=String(units[key]).padStart(2,'0');});}tick();const interval=setInterval(function(){if(!timer.isConnected){clearInterval(interval);return;}tick();},1000);});}initAparuLaunch();document.addEventListener('shopify:section:load',initAparuLaunch);

function openAparuPolicy(){var id=window.location.hash.slice(1);if(id!=='launch-legal'&&id!=='launch-privacy'&&id!=='launch-access')return;var panel=document.getElementById(id);if(panel){panel.open=true;panel.scrollIntoView({block:'start'});}}
document.addEventListener('click',function(event){var link=event.target.closest('a[href="#launch-legal"],a[href="#launch-privacy"],a[href="#launch-access"]');if(!link)return;var panel=document.querySelector(link.getAttribute('href'));if(panel)panel.open=true;});
window.addEventListener('hashchange',openAparuPolicy);openAparuPolicy();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.reset();
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.body.classList.remove('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
